module.exports = __webpack_public_path__ + "static/media/hero-tesla.0da646a6.png";